export default function Button(props) {
  if (typeof (props.value) === "string") {
    return (
      <input className="box button is-primary" type="button" value={props.value} onClick={props.click} />
    )
  }
  else return(
    <button className="box button is-primary" title={props.title} onClick={props.click}>{props.value}</button>
  )
}